import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import { Desktop, Mobile } from '../../../hoc/Responsive';

import CandidateColumns  from '../../../components/Client/CandidateReview/CandidateColumns';
import axios from '../../../services/axios-service';
import * as actions from '../../../store/actions/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import './review.css';
import Buttons from '../../../components/UI/Button/Button';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import MainJobTitle from '../../../components/Client/MainJobTitle/MainJobTitle'; 
import CsvIcon from '../../../assets/images/csv-file-format.svg';
import { scoringCriteria } from '../../../shared/constants';

/**
* @desc Review all candidate details under specific jobTitle -Client view
* @version 1.0.1
* @author Lakshmikanth, Mahesh  
*/
class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pool: {},
      columns: [],
      toggle: false,
      showSendWarning: false,
      showSendComplete: false,
      totalRecords: 0,
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastId:'',
      disableSendRecruiter:false
      
    }
    this.handleSendWarningShow = this.handleSendWarningShow.bind(this);
    this.handleSendWarningClose = this.handleSendWarningClose.bind(this);
    this.handleSendCompleteShow = this.handleSendCompleteShow.bind(this);
    this.handleSendCompleteClose = this.handleSendCompleteClose.bind(this);
    this.handleCandidateSelect = this.handleCandidateSelect.bind(this);
    this.handleCloseToastNotification = this.handleCloseToastNotification.bind(this);
  }

  /**
  * @desc redux call to get candidates data a according to specific job title on loading the page.
  * @param null
  * @return null
  */
  componentDidMount() {
    this.props.onGetGroupTalentPool(this.props.jobTitleId,this.props.user);
  }

  /**
  * @desc updates the candidates status and preferences with toggle,Drag and drop.
  * @param nextProps,nextState
  * @return null
  */
  componentDidUpdate(nextProps, nextState) {
    if(this.props.jobTitleId && this.props.jobTitleId !== nextProps.jobTitleId) {
      this.props.onGetGroupTalentPool(this.props.jobTitleId,this.props.user);
      this.props.onGetTalentPool(this.props.jobTitleId,this.props.user);
    }
    if(this.props.talentPool[0] && (this.props.talentPool[0].candidate_id !== nextProps.talentPool[0].candidate_id)&&this.props.talentPool.candidate_id !==undefined) {
      this.props.onViewCandidate(this.props.talentPool[0].candidate_id,this.props.jobTitleId);      
    }

    if((this.props.pool !== nextProps.pool)&&(!this.props.pool.message)) {
      const totalRecords = this.props.pool.pending.length + this.props.pool.progress.length + this.props.pool.regret.length;
      let columns = [
        {
          id: 1,
          title: 'Pending',
          status: "PENDING",
          data : this.props.pool.pending
        },
        {
          id: 2,
          title: 'Progress',
          status: "PROGRESS",
          data : this.props.pool.progress
        },
        {
          id: 3,
          title: 'Regret',
          status: "REGRET",
          data : this.props.pool.regret
        }
      ]; 
      this.setState({ pool : this.props.pool, columns: columns, totalRecords: totalRecords });
    }
  }

  handleSendWarningClose() {
    this.setState({ showSendWarning: false });
  }
  handleSendWarningShow() {
    this.setState({ showSendWarning: true });
  }

  handleSendCompleteClose() {
    this.setState({ showSendComplete: false });
  }

  handleSendCompleteShow() {
    this.setState({disableSendRecruiter:true})
    axios.get("/galaxy/recruiter/send-to-recruiter?jobId=" + this.props.jobTitleId +"&userId=" + this.props.clientDetails.user_id+"&userName="+this.props.clientDetails.user_fname +" "+ this.props.clientDetails.user_lname)
      .then((response) => {   
      if(response) {
        this.setState({ showSendWarning: false,
           showSendComplete: true,
           isShowToast: true,
           toastMessage:"Thank you! Your candidate list has been sent to your recruiter",
           toastVariant:'success',
           toastId: "tid" + (new Date()).getTime() ,
           disableSendRecruiter:false
            });
        }
    })
    .catch((error) => {
       ConsoleLog(error);
      throw error;
    });
  }
  handleCloseToastNotification(){
    this.setState({isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastAutoClose: false,
      toastId: ''
    })
  }
  handleCandidateSelect(CandidateId,jobTitleId) {
    this.props.onViewCandidate(CandidateId,jobTitleId);
    this.props.history.push('/');
  }

  handleCsvDownload = () => {
    let rows = [["Job Title", "Job ID", "Candidate Name","ID", "Current Job", scoringCriteria.default.scoringData.map(criteria => criteria.name), "Total Score", "Status"]];
    const candidatePool = [...this.props.candidatePool];
    if(candidatePool.filter((candidate) => candidate.candidate_status === "PROGRESS").length > 0) {
      const progressedCandidates = (candidatePool.filter((candidate) => candidate.candidate_status === "PROGRESS")
        .map((candidate) => [
          this.props.jobTitle,
          this.props.jobTitleBHID,
          candidate.candidate_fname + " " + candidate.candidate_lname,
          candidate.candidate_source_id,
          (candidate.current_job_title) ? candidate.current_job_title : "None",
          JSON.parse(candidate.candidate_scoring).map((score) => score.value),
          candidate.candidate_score,
          candidate.candidate_status
        ]));
        
      rows = rows.concat(progressedCandidates);
    }

    let csvContent = "data:text/csv;charset=utf-8,";
    rows.forEach(function(rowArray){
      let row = rowArray.join(",");
      csvContent += row + "\r\n";
    }); 

    const encodedUri = encodeURI(csvContent);
    let link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", this.props.jobTitle.replace(/\b\w/g, l => l.toUpperCase()) + " - " + this.props.jobTitleBHID + ".csv");
    document.body.appendChild(link); // Required for FF

    link.click(); // This will download the data file named "my_data.csv".
  }

  render() {    
    if(!this.state.pool || Object.keys(this.state.pool).length === 0) {
      return (null);
    }

    if(this.props.pool.message){
      const emptypoolMessage = <div style={{'min-height':'500px'}}>No profiles to display</div>;
      return (emptypoolMessage);
    }
    const companyType=this.props.companyType;
    return (
    	<div className="pool-review">
        <div className="client-top-section">
          <MainJobTitle 
            titleClass={"pool-title review"} 
            className={"main-job-head talentpool"} 
            user_id={ this.props.clientDetails.user_id } 
            currentPage="review"
          />
          {/* Desktop View CSV Export Section starts */}
          {companyType===1?<MediaQuery query="(min-device-width: 768px)">
            <div className={"cli-csv-export-div review" }>
              <Buttons className="cli-csv-export-button " onClick={this.handleCsvDownload}>
                Export CSV
                <img src={CsvIcon} />
              </Buttons>
            </div>
          </MediaQuery>:""}
          {/* Desktop View CSV Export Section Ends */}
        </div>
        <div className="pool-review-body">
          {/* <div className="send-recruiter">
            <Button 
              bsStyle="primary" 
              bsSize="large" 
              onClick={this.handleSendWarningShow}
            >
			        Send to Recruiter
			      </Button>
		      </div> */}
        	<Desktop>
						<div className="intro">
							<h1><strong>Review </strong> Candidate List</h1>
							<p>All candidates from the candidate list have been categorised. Please send the below list to your recruiter.</p>
						</div>
					</Desktop>
          <div className="pool-lists">  
            { this.state.columns.map((column, index) => (
              <CandidateColumns 
                status={column.status} 
                pool={column.data} 
                key={index} 
                handleToggleSwitch={this.toggleSwitch} 
                toggle={this.state.toggle} 
                totalRecords={this.state.totalRecords} 
                handleCandidateSelect={this.handleCandidateSelect}
              />
            )) } 
          </div>
		    </div>
        <Modal 
          className="pool-review-modal" 
          show={this.state.showSendWarning} 
          onHide={this.handleSendWarningClose}
        >
          <Modal.Body>
            <div className="no-cont">
              <div className="line"></div>
              <span className="cont-a">
                <span className="no-a">1</span>
                <p>Decision</p>
              </span>
              <span className="cont-a dis">
                <span className="no-a">2</span>
                <p>Review All</p>
              </span>
            </div>
          	<h1>Send to the recruiter</h1>
          	{/* <p>Are you ready to send your shortlist to the recruiter?</p> */}
            <Link to="/"> 
              <Button 
                bsStyle="primary" 
              >Go back to Candidate List
              </Button>
            </Link>
            <Button 
            className={this.state.disableSendRecruiter?"send-recruiter-modal-button-disabled":"send-recruiter-modal-button"}
              onClick={this.handleSendCompleteShow} 
              bsStyle="warning"
              disabled={this.state.disableSendRecruiter?true:false}
            >Send</Button>
          </Modal.Body>
        </Modal>
        {/* <Modal 
          className="pool-review-modal thank-you-modal" 
          show={this.state.showSendComplete} 
          onHide={this.handleSendCompleteClose}
        >
          <Modal.Body>
          <div className="no-cont">
              <div className="line"></div>
              <span className="cont-a">
                <span className="no-a">1</span>
                <p>Decision</p>
              </span>
              <span className="cont-a dis">
                <span className="no-a">2</span>
                <p>Review All</p>
              </span>
            </div>
          	<h1>Thank you!</h1>
          	<div className="thank-you-content">Your Candidate List has been sent to your recruiter.</div>
            <Link to="/">
              <Button 
                  bsStyle="warning"                   
                >
                  Back to Candidate List
              </Button>
            </Link>
          </Modal.Body>
        </Modal> */}
        <ToastNotification 
          isShowToast={this.state.isShowToast} 
          message={this.state.toastMessage} 
          variant={this.state.toastVariant} 
          autoClose={this.state.toastAutoClose}
          onClose={this.handleCloseToastNotification}
          toastId={this.state.toastId}
        />
        <div className="reviewAll-prev-button">  
          <div className="stepper-previous-button">
            <Buttons
              onClick={ ()=>window.history.back() } 
              size="small" 
              className="reviewAll-previous-button" 
              buttonicon="previous-icon"
            />
          </div>
        </div>
	    </div>
    );
  }
}

const mapStateToProps = state => {
  return {
      pool: state.groupTalentPool.groupedPool,
      talentPool:state.talentPool.pool,
      jobTitleId: state.talentPool.jobTitleId,
      clientDetails: state.clientProfile.clientDetails,
      user:state.cognito.user,
      clientDetails: state.clientProfile.clientDetails,
      companyType:state.talentPool.companyType,      
      jobTitle: state.talentPool.jobTitle,
      jobTitleBHID: state.talentPool.jobTitleBHID,
      candidatePool: state.talentPool.pool
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onGetGroupTalentPool: (jobTitleId,user) => dispatch(actions.getGroupedTalentPool(jobTitleId,user)),
    onViewCandidate: (canidateId,jobTitleId) => dispatch(actions.viewCandidate(canidateId,jobTitleId)),
    onGetTalentPool: (jobTitleId,user) => dispatch(actions.getTalentPool(jobTitleId,user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Review,axios));


// WEBPACK FOOTER //
// ./src/container/Client/Review/Review.js